<template>
  <div class="schedule">
    <div class="section">
      <div class="container">
        <h1 class="title is-spaced">Schedule</h1>
        <h2 class="subtitle">The schedule below is auto adjusted to your timezone</h2>
      </div>
    </div>
    <div class="schedule-table">
      <div class="container">
        <table class="table">
          <thead>
            <tr>
              <th>
                <abbr title="Estimated">Est.</abbr> Date
              </th>
              <th class="duration">
                <abbr title="Estimated">Est.</abbr> Duration
              </th>
              <th>Game</th>
              <th>Year</th>
              <th>Platform</th>
            </tr>
          </thead>
          <tbody>
            <tr v-for="(game, index) in schedule" :key="`game-${index}`">
              <td>
                <span class="fa fa-calendar"></span>
                <span>{{ game.date | localDate }}</span>
              </td>
              <td class="duration cell-number">
                <span class="fa fa-clock-o"></span>
                {{ game.duration | durationToHours }}
              </td>
              <td>
                <span class="fa fa-gamepad"></span>
                <span>{{ game.name }}</span>
              </td>
              <td>
                <span>{{ game.year }}</span>
              </td>
              <td>
                <span>{{ game.platform }}</span>
              </td>
              <td>
                <template v-if="game.notes">
                  <span class="fa fa-comment"></span>
                  <span>{{ game.notes }}</span>
                </template>
              </td>
              <template v-if="game.donation_total && game.donation_total.length > 0">
                <td class="donation_total">
                  <span class="fa fa-arrow-up"></span>
                  <span v-html="`$${game.donation_total.join('<br/><br/> $')}`"></span>
                </td>
                <td class="donation_unlock">
                  <span class="fa fa-comments"></span>
                  <span v-html="game.donation_unlock.join('<br/><br/>')"></span>
                </td>
              </template>
              <td v-else colspan="2" class="no-padding"></td>
            </tr>
          </tbody>
        </table>
      </div>
    </div>
  </div>
</template>

<script>
import moment from "moment";

export default {
  name: "schedule",
  data() {
    return {
      schedule: [],
      startUnixTimestamp: 0
    };
  },

  mounted() {
    this.http
      .get(`http://horaro.org/-/api/v1/events/trm/schedules/iv`)
      .then(response => {
        if (response.status !== 200) return;

        var data = response.data;
        console.log(data);
      });
  },

  filters: {
    localDate(date) {
      return moment(date)
        .local()
        .format("ddd Do MMM Y, hh:mma");
    },

    durationToHours(minutes) {
      return minutes / 60 + " hrs";
    }
  },

  methods: {}
};
</script>

<style scoped lang="scss">
/* $table-background-color: rgba(255, 255, 255, 0.75); */
$table-cell-border: 1px solid darken($default-border-col, 15%);

@media screen and (max-width: $phone-size) {
  $table-row-hover-background-color: transparent;
  $table-row-active-background-color: transparent;
}

@import "~bulma/sass/layout/section";
@import "~bulma/sass/elements/table";

.section {
  @media screen and (max-width: $phone-size) {
    padding: 1.5em;
  }
}

.schedule-table {
  /* 	background: url("~/static/images/splash-images/what-is.jpg");
	background-position: center; */
  padding: 20px 0;

  .container {
    display: flex;
    justify-content: center;

    @media screen and (max-width: $phone-size) {
      display: inline-block;
      padding: 15px;
      overflow-x: auto;
      width: 100%;
    }
  }

  .table td {
    vertical-align: middle;

    span {
      clear: none;
      float: left;
      display: inline-block;
      width: auto;

      &:not(.fa) {
        width: calc(100% - 30px);
      }
    }

    &.no-padding {
      padding: 0;
    }
  }

  .fa {
    margin-right: 10px;
  }

  .duration {
  }

  /* @media screen and (max-width: $phone-size) { */
  width: 100%;

  .table {
    overflow-x: auto;
    width: 100%;
  }
  /* } */

  @media screen and (max-width: $phone-size) {
    .table thead {
      display: none;
    }

    .table tr {
      border-bottom: $table-cell-border;
    }

    .table td {
      border: 0;
      clear: both;
      float: left;
      width: 100%;

      &.donation_total,
      &.donation_unlock {
        clear: none;
        width: auto;
      }
    }
  }
}
</style>


// WEBPACK FOOTER //
// index.vue?49fcb458